import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Spinner,
  Alert,
} from "reactstrap";
import { Link } from "react-router-dom";
import "chartist/dist/scss/chartist.scss";
import { withTranslation } from "react-i18next";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import axios from "axios/axios.js";
import { MDBDataTable } from "mdbreact";
import AddEditCategory from "./AddEditCategory.js";

const Categories = () => {
  const columns = [
    {
      label: "Name",
      field: "name",
      sort: "asc",
    },
    {
      label: "Name (AR)",
      field: "nameAr",
      sort: "asc",
    },
    {
      label: "Image",
      field: "image",
      sort: "asc",
    },
    {
      label: "",
      field: "actions",
    },
  ];
  const categoryInitial = {
    name: "",
    nameFr: "",
    nameIt: "",
    priority: "",
  };
  const [menu, setMenu] = useState(false);
  const [reload, setReload] = useState(false);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(categoryInitial);
  const [selectedCategory, setSelectedCategory] = useState();
  const [error, setError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [addEditErrorMsg, setAddEditErrorMsg] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setError(false);
    axios
      .get("products/categories", {
        headers: {
          Authorization: sessionStorage.getItem("token"),
        },
      })
      .then((res) => {
        setError(false);
        setLoading(false);
        setCategories(res.data.categories);
      })
      .catch((e) => {
        setLoading(false);
        setError(true);
      });
  }, [reload]);

  const handleDelete = (id) => {
    setErrorMsg("");
    let confirm = window.confirm(
      "You are about delete this category, do you wish to continue?"
    );
    if (confirm) {
      axios
        .delete(`products/deleteCategory/${id}`, {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          setReload(!reload);
        })
        .catch((e) => {
          setErrorMsg(e.response.data?.message);
        });
    }
  };

  return loading ? (
    <React.Fragment>
      <div className="page-content">
        <Container
          fluid
          style={{
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spinner size={"lg"} color="primary" />
        </Container>
      </div>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="page-title-box">
            <Row className="align-items-center">
              <Col md={8}>
                <h5 className="page-title">Categories</h5>
              </Col>
            </Row>
          </div>

          <Row className="mb-4">
            <Col>
              <Accordion expanded={menu} style={{ boxShadow: "none" }}>
                <AccordionSummary
                  style={{ backgroundColor: "#E9ECEF" }}
                  onClick={() => {
                    setMenu(!menu);
                  }}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <h6
                    style={{
                      fontWeight: "bold",
                      color: "#5B626B",
                    }}
                  >
                    {selectedCategory ? "Edit Category" : "Add Category"}
                  </h6>
                </AccordionSummary>
                <AccordionDetails>
                  <AddEditCategory
                    selectedCategory={selectedCategory}
                    setSelectedCategory={setSelectedCategory}
                    category={category}
                    setCategory={setCategory}
                    setReload={setReload}
                    error={addEditErrorMsg}
                    setError={setAddEditErrorMsg}
                  />
                </AccordionDetails>
              </Accordion>
            </Col>
          </Row>

          <Row>
            <Col>
              <Card>
                <CardHeader>
                  <h6 style={{ fontWeight: "bold" }}>Categories List</h6>
                </CardHeader>
                <CardBody>
                  {errorMsg && <Alert color="danger">{errorMsg}</Alert>}
                  <MDBDataTable
                    hover
                    responsive
                    noBottomColumns
                    data={{
                      columns: columns,
                      rows: categories.map((one) => {
                        return {
                          ...one,
                          image: (
                            <Col xs={4} md={2}>
                              <img
                                src={one.image}
                                style={{ width: "120px", height: "10vh" }}
                              />
                            </Col>
                          ),
                          actions: (
                            <Row>
                              <Col xs={4} md={2}>
                                <Link
                                  to="#"
                                  className="btn btn-danger btn-sm mr-2"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setAddEditErrorMsg("");
                                    handleDelete(one._id);
                                  }}
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </Col>
                              <Col xs={4} md={2}>
                                <Link
                                  to="#"
                                  className="btn btn-primary btn-sm"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setAddEditErrorMsg("");
                                    if (
                                      selectedCategory &&
                                      selectedCategory._id === one._id
                                    ) {
                                      setCategory(categoryInitial);
                                      setSelectedCategory(null);
                                      setMenu(false);
                                    } else {
                                      setCategory(one);
                                      setSelectedCategory(one);
                                      setMenu(true);
                                    }
                                  }}
                                >
                                  {selectedCategory &&
                                  selectedCategory._id === one._id ? (
                                    <i
                                      className="ion ion-md-close"
                                      style={{
                                        color: "white",
                                      }}
                                    ></i>
                                  ) : (
                                    <i className="fas fa-edit"></i>
                                  )}
                                </Link>
                              </Col>
                            </Row>
                          ),
                        };
                      }),
                    }}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

Categories.propTypes = {
  t: PropTypes.any,
};

export default withTranslation()(Categories);
